import { render, staticRenderFns } from "./ExpenseRegister.vue?vue&type=template&id=e842daca"
import script from "./ExpenseRegister.vue?vue&type=script&lang=js"
export * from "./ExpenseRegister.vue?vue&type=script&lang=js"
import style0 from "./ExpenseRegister.vue?vue&type=style&index=0&id=e842daca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports